<template>
  <div class>
    <div slot="header" class="clearfix" style="background-color: #f2f2f2; padding: 20px">
      <span style="font-weight: 600; color: #000; line-height: 10px">品牌型号</span>
    </div>
    <el-form :model="form" :rules="rules" ref="form" label-width="120px" style=" margin-top: 20px;">
      <el-form-item label="品牌名称" prop="brandName" style="width: 400px;">
          <!-- <el-select v-model="form.brandName" filterable remote reserve-keyword placeholder="请输入品牌名称" :remote-method="selectBrandName">
            <el-option v-for="item in brandList" :key="item.name" :label="item.name" :value="item.name"></el-option>
          </el-select> -->
          <el-autocomplete v-model="form.brandName" :fetch-suggestions="selectBrandName" :trigger-on-focus="false" placeholder="请输入品牌名称" @select="handleSelect"></el-autocomplete>
      </el-form-item>
      <el-form-item label="型号名称" prop="modelName" style="width: 400px;">
          <!-- <el-select v-model="form.modelName" filterable remote reserve-keyword placeholder="请输入型号名称" :remote-method="selectModelName">
            <el-option v-for="item in modelList" :key="item.name" :label="item.name" :value="item.name"></el-option>
          </el-select> -->
          <el-autocomplete v-model="form.modelName" :fetch-suggestions="selectModelName" :trigger-on-focus="false" placeholder="请输入型号名称" @select="handleSelect2"></el-autocomplete>
      </el-form-item>
      <el-form-item label="装机电量" prop="electricity" style="width: 400px;">
          <el-input v-model="form.electricity" placeholder="请输入装机电量"></el-input>
      </el-form-item>
    </el-form>

    <div class="btns" style="margin-top: 30px;display: flex;align-items: center;justify-content: center;">
      <el-button @click="cancel" class="resetbtn">取消</el-button>
      <el-button type="success" @click="save">保存</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "xinzengpinpaixinghao",
  components: {},
  data() {
    return {
      form:{
        brandName:'',
        modelName:'',
        electricity:'',
      },
      brandList:[],
      modelList:[],
      rules:{
        brandName:[
          { required: true,message: "请输入品牌名称",trigger: "blur",}
        ],
        modelName:[
          { required: true,message: "请输入型号名称",trigger: "blur",}
        ],
        electricity:[
          { required: true,message: "请输入装机电量",trigger: "blur",}
        ]
      }
    };
  },
  computed: {},
  methods: {
    selectBrandName(queryString, cb) {
      let data = {
          brandName: queryString,
      };
      this.$store.dispatch("form/handle", {
          url: "/battery/brand/getBrandName",
          data: data,
          method: "get",
          callback: (resp) => {
            if(resp){
              this.brandList = resp.map((res)=>{
                return {
                  value:res.name,
                  name:res.name
                };
              })
              cb(this.brandList);
            }
          },
      });
    },
    selectModelName(queryString, cb) {
      let data = {
          modelName: queryString,
      };
      this.$store.dispatch("form/handle", {
          url: "/battery/brand/getModelName",
          data: data,
          method: "get",
          callback: (resp) => {
            if(resp){
              this.modelList = resp.map((res)=>{
                return {
                  value:res.name,
                  name:res.name
                };
              })
              cb(this.modelList);
            }
          },
      });
    },
    handleSelect(e){
      console.log(e,3333)
    },
    handleSelect2(e){
      console.log(e,3333)
    },
    cancel() {
      this.$router.go(-1);
    },
    // // save() {
    async save() {
      try {
        //必填校验
        await Promise.all([
          this.$refs.form.validate(),
        ]);
      } catch (error) {
        return;
      }
      let data = {
        brandName: this.form.brandName,
        modelName: this.form.modelName,
        electricity:this.form.electricity,
      };
      this.$store.dispatch("form/handle", {
        url: "/battery/brand/put",
        data: data,
        method: "put",
        callback: (resp) => {
          this.$router.go(-1);
        },
      });
    },
  },
  mounted() {},
  created() {
  },
  beforeCreate() {
  }, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style lang="less" src="" scoped>
.btn {
  width: 600px;
  height: 50px;
  margin-top: 10px;
  margin-left: 40%;
}
.resetbtn:hover {
  border: 1px solid #00cc00;
  color: #00cc00;
}
.resetbtn:active {
  border: 1px solid #00cc00;
  color: #ffffff;
  background-color: #00cc00;
}
</style>



// WEBPACK FOOTER //
// src/views/BMS/deviceManagement/addBrandModel.vue